import { render, staticRenderFns } from "./suggestion-list.vue?vue&type=template&id=09047065&scoped=true"
import script from "./suggestion-list.vue?vue&type=script&lang=js"
export * from "./suggestion-list.vue?vue&type=script&lang=js"
import style0 from "./suggestion-list.vue?vue&type=style&index=0&id=09047065&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09047065",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09047065')) {
      api.createRecord('09047065', component.options)
    } else {
      api.reload('09047065', component.options)
    }
    module.hot.accept("./suggestion-list.vue?vue&type=template&id=09047065&scoped=true", function () {
      api.rerender('09047065', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/suggestion-management/suggestion-list.vue"
export default component.exports